
import React, { useState } from 'react';
import Select from 'react-select';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
} from 'reactstrap'
import { fetcher } from 'api/client';
import { useMutation, useQuery } from 'react-query';
// import {linkContract} from 'api/actions/contracts';
import bootbox from 'components/Modals/Bootbox';
import { useTranslation } from 'react-i18next';
import { fetchContractList, linkContract } from 'api/actions/contracts';
import { toast } from 'components/Shared/Toast';
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

function CreateReferenceModal({ isOpen, toggle, contract, onSave, handleChangeContract, handleChangeSearch, isLoading, searchText, selectedContract, data }) {

    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} centered>
            <ModalHeader toggle={toggle}>
                {t('contracts.reference.title')}<br></br>
                <small>{t('contracts.reference.subtitle')}</small>
            </ModalHeader>
            <ModalBody>
                <p>
                    {t('contracts.reference.instructions')}
                </p>
                <FormGroup>
                    <label>{t('contracts.reference.name')}:</label>
                    <Select
                        styles={reactSelectStyles}
                        placeholder={t('common.choose')}
                        isClearable={true}
                        isLoading={isLoading}
                        inputValue={searchText}
                        value={selectedContract}
                        options={
                            // Remove self and already referenced documents
                            data?.docs?.filter(d => d._id !== contract._id && !d.reference.length && !d.parentReference)
                                .map((doc) =>
                                    ({ value: doc._id, label: `${doc.documentId} - ${doc.name}` })
                                )
                        }
                        getOptionLabel={o => o.label}
                        noOptionsMessage={() => t('common.no_options')}
                        onChange={handleChangeContract}
                        onInputChange={handleChangeSearch}
                    />
                </FormGroup>

                {/* <div className="reference-contracts-wrapper">
                            <span>{contract?.name}</span>
                            <span className="type-name">
                                {contract?.type?.name}
                            </span> */}
                {/* </div> */}

                <div className="text-center">
                    <Button type="button" size="md" onClick={toggle}>
                        {t('contracts.reference.cancel')}
                    </Button>
                    <Button className="ml-2" size="md" color="primary" type="button" onClick={onSave}>
                        <i className="fas fa-save"></i> {t('contracts.reference.save')}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

function CreateReferenceModalContainer({ isOpen, toggle, onSave = () => { }, contract }) {

    const [selectedContract, setSelectedContract] = useState('');
    const [searchText, setSearchText] = useState('');

    const { t } = useTranslation();

    const { mutate: mutateLink } = useMutation((payload) => fetcher(linkContract(payload)), {
        onSuccess: () => {
            toast.success(t('contracts.reference.reference_success'))
            toggle()
            onSave()
            setSelectedContract()
        },
        onError: (error) => {
            toast.error(t(`errors.${error.message}`, t('contracts.reference.reference_error')))
        }
    })

    const handleSave = async () => {
        if (!selectedContract?.value) return;
        if (!await bootbox.confirm(t('contracts.options.reference_confirm'))) return;
        mutateLink({ parentId: contract._id, childId: selectedContract.value });
    }

    const { data, isLoading } = useQuery(['fetch-folders-search', searchText], () =>
        fetcher(
            fetchContractList({
                url: '/contracts/all',
                page: 1,
                perPage: 10,
                search: `name|${searchText}`,
                limit: 30,
                filterown: true
            })),
        {
            enabled: isOpen
        });

    const handleChangeContract = (selectedItem, event) => {
        setSelectedContract(selectedItem);
    };

    const handleChangeSearch = (inputText, event) => {
        if (event.action !== 'input-blur' && event.action !== 'menu-close') {
            setSearchText(inputText);
        }
    };

    return (
        <CreateReferenceModal
            isOpen={isOpen}
            toggle={toggle}
            contract={contract}
            onSave={handleSave}
            handleChangeContract={handleChangeContract}
            handleChangeSearch={handleChangeSearch}
            isLoading={isLoading}
            searchText={searchText}
            selectedContract={selectedContract}
            data={data}
        />
    )
}

export default CreateReferenceModalContainer;